module.exports = __webpack_public_path__ + "img/social-icon-instagram.fd241362.svg";